import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import { i18n } from "../../translate/i18n";
import { ModalTitle, FormField } from "../QueueIntegrationModal/panelKit";

const FlowBuilderIntervalModal = ({
  open,
  onSave,
  data,
  onUpdate,
  close
}) => {
  const isMounted = useRef(true);

  const [timerSec, setTimerSec] = useState(0)
  const [activeModal, setActiveModal] = useState(false)

  useEffect(() => {
    if(open === 'edit'){
      setTimerSec(data.data.sec)
      setActiveModal(true)
    } else if(open === 'create'){
      setTimerSec(0)
      setActiveModal(true)
    }
    return () => {
      isMounted.current = false;
    };
  }, [open]);
  

  const handleClose = () => {
    close(null)
    setActiveModal(false)
  };

  const handleSaveContact = async values => {
    if(!timerSec || parseInt(timerSec)  <= 0){
      return toast.error('Adicione o valor de intervalo')
    }
    if(parseInt(timerSec) > 120){
      return toast.error('Máximo de tempo atingido 120 segundos')
    }
    if(open === 'edit'){
      onUpdate({
        ...data,
        data: { sec: timerSec }
      });
    } else if(open === 'create'){
      onSave({
        sec: timerSec
      })
    }
    handleClose()
    
  };

  return (
    <Dialog open={activeModal} onClose={handleClose} fullWidth maxWidth="xs" scroll="paper">
      <ModalTitle
        id="form-dialog-title"
        title={open === 'create' ? `Adicionar um intervalo ao fluxo`: `Editar intervalo`}
        subtitle="Espera alguns segundos antes de seguir para o próximo passo."
        onClose={handleClose}
      />
      <DialogContent>
        <FormField
          label="Tempo em segundos"
          htmlFor="flow-interval-seconds"
          help="De 1 a 120 segundos."
        >
          <TextField
            id="flow-interval-seconds"
            name="timer"
            type="number"
            value={timerSec}
            onChange={(e) => setTimerSec(e.target.value)}
            autoFocus
            variant="outlined"
            size="small"
            fullWidth
            InputProps={{ inputProps: { min: 0 } }}
          />
        </FormField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {i18n.t("contactModal.buttons.cancel")}
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          onClick={() => handleSaveContact()}
        >
          {open === 'create' ? `Adicionar` : 'Editar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderIntervalModal;
